import LayoutContentArea from "@/components/layout/LayoutContentArea";
import FeatureFlagsSection from "@/components/site-administration/FeatureFlagsSection";

export default function FeatureFlagsPage() {
  return (
    <LayoutContentArea headingText="Feature Flags">
      <p
        style={{
          color: "#000",
          marginTop: "-1rem",
          marginBottom: "1.5rem",
          maxWidth: "900px",
        }}
      >
        Turn feature flags on or off for the entire site.
      </p>
      <FeatureFlagsSection />
    </LayoutContentArea>
  );
}
